export default __webpack_public_path__ + "static/media/volnovaha-rayon.52ac0d62.png";